var exports = {
  "Qs": "xaee3c4fa--587446--content",
  "Xm": "xaee3c4fa--587446--article-container",
  "hr": "xaee3c4fa--587446--content__container",
  "EI": "xaee3c4fa--587446--content__read-topic",
  "G1": "xaee3c4fa--587446--content-bottom-block",
  "ah": "xaee3c4fa--587446--search-visible",
  "AK": "xaee3c4fa--587446--content-search-visible",
  "QC": "xaee3c4fa--587446--adfox-banner-footer",
  "VR": "xaee3c4fa--587446--_with-new-menu",
  "sl": "xaee3c4fa--587446--content__container_info",
  "mk": "xaee3c4fa--587446--sidebar-new",
};

module.exports = exports;
